import { render, staticRenderFns } from "./Searches.vue?vue&type=template&id=6f04f7eb&scoped=true&"
import script from "./Searches.vue?vue&type=script&lang=js&"
export * from "./Searches.vue?vue&type=script&lang=js&"
import style0 from "./Searches.vue?vue&type=style&index=0&id=6f04f7eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f04f7eb",
  null
  
)

export default component.exports